import type { TFunction } from 'i18next';

import { formatDate } from '../../../utils/helpers/date';

const toDate = (iso: string) => {
	const date = new Date(iso);
	return Number.isNaN(date.getTime()) ? null : date;
};

/** "14:05", the inbox's clock. */
export const formatChatTime = (iso: string) =>
	toDate(iso)?.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) ?? '';

/** The calendar day a message belongs to, for the date separators. */
export const chatDayKey = (iso: string) => toDate(iso)?.toDateString() ?? '';

/** "Today", "Yesterday", else the inbox's date. */
export const formatChatDay = (iso: string, t: TFunction) => {
	const date = toDate(iso);
	if (!date) return '';
	const today = new Date();
	const yesterday = new Date(today);
	yesterday.setDate(today.getDate() - 1);

	if (date.toDateString() === today.toDateString()) {
		return t('T_SITE_CHAT_TODAY', { defaultValue: 'Today' });
	}
	if (date.toDateString() === yesterday.toDateString()) {
		return t('T_SITE_CHAT_YESTERDAY', { defaultValue: 'Yesterday' });
	}
	return formatDate(iso);
};

/** The conversations list's stamp: the time today, else the date. */
export const formatConversationStamp = (iso: string) => {
	const date = toDate(iso);
	if (!date) return '';
	return date.toDateString() === new Date().toDateString() ? formatChatTime(iso) : formatDate(iso);
};
